
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class NotesInput extends Vue {
  @Model("input", { type: String }) readonly value!: string;
  @Prop({ type: String, default: "Notes" }) readonly labelEmpty!: string;
  @Prop({ type: String, default: "Notes" }) readonly labelFilled!: string;
  @Prop({ type: String, default: "Notes" }) readonly dialogTitle!: string;
  @Prop({ type: String, default: "outlined" }) readonly actionVariant!: "text" | "outlined";
  @Prop({ type: String, default: "primary" }) readonly saveColor!: string;
  @Prop({ type: [String, Number], default: 600 }) readonly maxWidth!: string | number;
  @Prop({ type: Boolean, default: true }) readonly showPreview!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isRequired!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isLocked!: boolean;

  dialog: boolean = false;
  draft: string = "";

  openDialog() {
    if (this.isLocked) {
      return;
    }

    this.draft = this.value || "";
    this.dialog = true;
    this.$nextTick(() => requestAnimationFrame(() => (this.$refs.notesInput as any)?.focus()));
  }

  closeDialog() {
    this.dialog = false;
  }

  @Watch("dialog")
  onDialogChanged(nextValue: boolean, previousValue: boolean) {
    if (previousValue && !nextValue) {
      this.$nextTick(() => requestAnimationFrame(() => (document.activeElement as HTMLElement | null)?.blur()));
    }
  }

  save() {
    this.$emit("input", this.draft);
    this.closeDialog();
  }
}
